<mat-dialog-actions class="justify-content-between">
  <h3>
    {{ (readOnly ? 'LABEL.VIEW_LABEL' : 'LABEL.ADD_LABEL') | translate }}
    {{ 'LABEL.DISCHARGE' | translate }}
  </h3>
  <div class="d-flex justify-content-center">
    <a mat-icon-button color="primary" (click)="printDischargeDetails()" *ngIf="isUpdateMode && readOnly">
      <i-tabler name="printer" class="icon-25 d-flex text-primary"></i-tabler>
    </a>
    <button mat-icon-button mat-dialog-close>
      <i-tabler name="x" class="icon-25 d-flex"></i-tabler>
    </button>
  </div>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content [formGroup]="dischargeForm">
  <div *ngIf="isLoading" class="loader-wrapper">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  <div class="row" *ngIf="!isLoading">
    <!-- Discharge Date -->
    <div class="col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'LABEL.DISCHARGE_DATE' | translate }}</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="dischargeDate" [min]="minDate" required
          [max]="maxDate" [readonly]="readOnly">
        <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="readOnly"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="dischargeForm.get('dischargeDate')?.hasError('required')">
          {{ 'REQUIRED.SELECT_DATE' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Discharge Time -->
    <div class="col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'LABEL.DISCHARGE_TIME' | translate }}</mat-label>
        <input matInput type="time" formControlName="dischargeTime" [readonly]="readOnly">
        <mat-error *ngIf="dischargeForm.get('dischargeTime')?.hasError('required')">
          {{ 'REQUIRED.SELECT_TIME' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Diagnosis (Read-only, from OPD Clinical) -->
    <div class="col-sm-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'LABEL.DIAGNOSIS' | translate }}</mat-label>
        <textarea matInput formControlName="diagnosis" rows="3" readonly></textarea>
      </mat-form-field>
    </div>

    <!-- Final Diagnosis -->
    <div class="col-sm-12">
      <div class="d-flex align-items-center gap-8">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'LABEL.FINAL_DIAGNOSIS' | translate }}</mat-label>
          <textarea matInput formControlName="finalDiagnosis" rows="3" [readonly]="readOnly"></textarea>
          <a mat-icon-button matSuffix type="button" (click)="copyDiagnosisToFinal()"
            [matTooltip]="'BUTTON.COPY_FROM_DIAGNOSIS' | translate" [disabled]="readOnly">
            <i-tabler name="copy" class="icon-18"></i-tabler>
          </a>
        </mat-form-field>

      </div>
    </div>

    <!-- Treatment Advice -->
    <div class="col-sm-12">
      <div class="d-flex align-items-center gap-8">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'LABEL.TREATMENT_ADVICE' | translate }}</mat-label>
          <textarea matInput formControlName="treatmentAdvice" rows="4" [readonly]="readOnly"></textarea>
          <a mat-icon-button matSuffix type="button" (click)="openTemplatePopupforTreatmentAdvice()"
            [matTooltip]="'ENTITY.TEMPLATE' | translate" [disabled]="readOnly">
            <i-tabler name="file-text" class="icon-18"></i-tabler>
          </a>
        </mat-form-field>
      </div>
    </div>

    <div class="col-sm-12">
      <div class="d-flex align-items-center gap-8">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'LABEL.DISCHARGE_CONDITION' | translate }}</mat-label>
          <textarea matInput formControlName="dischargeCondition" rows="4" [readonly]="readOnly"></textarea>
          <a mat-icon-button matSuffix type="button" (click)="openTemplatePopup()"
            [matTooltip]="'ENTITY.TEMPLATE' | translate" [disabled]="readOnly">
            <i-tabler name="file-text" class="icon-18"></i-tabler>
          </a>
        </mat-form-field>
      </div>
    </div>

    <!-- Prescription (Medication) - Commented out for now -->
    <!-- <div class="col-sm-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Prescription (Medication)</mat-label>
        <textarea matInput formControlName="prescription" rows="4"></textarea>
      </mat-form-field>
    </div> -->
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
  <div class="row p-r-16">
    <div class="col-lg-6 d-flex justify-content-start">
    </div>
    <div class="col-lg-6 d-flex justify-content-end">
      <button mat-stroked-button class="m-r-5" (click)="close()">{{ 'BUTTON.BTN_CLOSE' |
        translate}}</button>
      <button mat-flat-button color="primary" class=" m-l-4" (click)="save()" [disabled]="dischargeForm.invalid"
        *ngIf="!readOnly">{{
        'BUTTON.BTN_SAVE' | translate }}</button>
    </div>
  </div>
</mat-dialog-actions>